import moment from "moment";
// For Eastern Timezone
// import moment_timezone from "moment-timezone";
import XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Fuse from "fuse.js";
import swal from "sweetalert2";

export default class Util {
  constructor() {
    throw new Error("This class can't be instantiated.");
  }

  static LOGIN_METHOD_CAC = "CAC";
  static STANDARD = 4;
  static OPEN_ENDED = 5;
  static SME_LOAN = 1;
  static STRATEGIC_AIRLIFT = 2;
  static LIFT_AND_SUSTAIN = 3;
  static MONETARY = 1;
  static RIK = 2;
  static EVE = 3;
  static US_BUY = "BUY";
  static US_SELL = "SELL";
  static ORDER_STATUS_DRAFT = "DRAFT";
  static ORDER_STATUS_SUBMITTED = "SUBMITTED";
  static ORDER_STATUS_AUTHORIZED = "AUTHORIZED";
  static ORDER_STATUS_RECEIVED = "RECEIVED";
  static ORDER_STATUS_RETURNED = "RETURNED";
  static ORDER_STATUS_INVOICED = "INVOICED";
  static ORDER_STATUS_BILLED = "BILLED";
  static ORDER_STATUS_COMPLETED = "COMPLETED";
  static ORDER_STATUS_CANCELLED = "CANCELLED";
  static TRANSACTION_COMPLETION = "TRANSACTION COMPLETION";
  static TRANSACTION_COMPLETED = "TRANSACTION COMPLETED";
  static TRANSACTION_AUTHORIZATION = "TRANSACTION AUTHORIZATION";
  static FINANCIAL_VALIDATION = "FINANCIAL VALIDATION";
  static RECEIVING_REPORT = "RECEIVING REPORT";
  static INVOICE = "INVOICE";
  static BILL = "BILL";
  static RETURN_REPLACEMENT = "RETURN REPLACEMENT";
  static PARTNER_NATION = "PartnerNation";
  static PM1 = "PM1";
  static PARTNER_NATION_MANAGER = "PartnerNationManager";
  static ORDER_IS_COMPLETE_MESSAGE =
    "The order is completed, you can no longer make any changes to it.";
  static SIGNATURE_DATE_ADDED_WITHOUT_SIGNATURE_OR_DOCUMENT_UPLOADED =
    "Signature date cannot be added without signature or document!";
  static LOGISTICS_TYPE_ID = 2;
  static FINANCE_TYPE_ID = 3;
  static PARTNER_NATION_TYPE_ID = 4;
  static PENDING = 1;
  static APPROVED = 2;
  static REJECTED = 3;
  static LOCKED = 4;

  static COMPLETED_TAB = 6;
  static isLegacyOrder(createDate) {
    return Date.parse(createDate) < new Date("02/20/2021 00:00");
  }

  static isString(data) {
    return typeof data === "string";
  }

  static fileDownload(file, title) {
    var fileURL = window.URL.createObjectURL(new Blob([file]));
    var fileLink = document.createElement("a");

    fileLink.href = fileURL;
    fileLink.setAttribute("download", title);
    document.body.appendChild(fileLink);

    fileLink.click();
  }

  static formatDateForServer(dateValue) {
    let result = null;

    if (!Util.isNullOrEmpty(dateValue)) {
      const dateMoment = moment(dateValue);
      result = dateMoment.format("MM-dd-yyyyTHH:mm:ss");
    }

    return result;
  }

  static getSignatureImageFromDataString(dataString) {
    let self = this;
    return new Promise(function (resolve, reject) {
      if (self.isNull(dataString)) {
        return resolve(null);
      } else {
        let image = new Image();
        image.src = dataString;
        image.onload = function () {
          let imageWidth;
          let imageHeight;
          const MAX_SIGNATURE_WIDTH = 400;
          const MAX_SIGNATURE_HEIGHT = 200;
          imageWidth = MAX_SIGNATURE_WIDTH;
          imageHeight =
            (imageWidth * image.height) / image.width;
          if (imageHeight > MAX_SIGNATURE_HEIGHT) {
            imageHeight = MAX_SIGNATURE_HEIGHT;
            imageWidth =
              (imageHeight * image.width) / image.height;
          }
          image.width = imageWidth;
          image.height = imageHeight;
          return resolve(image);
        };
      }
    });
  }

  static numberWithCommas(numberValue) {
    if (Util.isNullOrEmpty(numberValue)) {
      return "";
    }

    let numberString = parseInt(numberValue)
      .toFixed(2)
      .toString();

    let parts = numberString.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts[1] === "00" ? parts[0] : parts.join(".");
  }

  static inMoneyFormatWithoutDollarSign(number) {
    return number.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 10,
    });
  }

  static inMoneyFormatWithDollarSign(number) {
    if (typeof number === "number") {
      return number.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 10,
      });
    } else {
      return;
    }
  }

  static isNull(value) {
    return value === null || value === undefined;
  }

  static isNullOrEmpty(value) {
    // The \u009eée is what happens when you give null to javascript atob function.  Do not remove it.  It is used for null signatures.
    return (
      value === null ||
      value === undefined ||
      value.length <= 0 ||
      value == "\u009eée"
    );
  }

  static getSmallScreenWidth() {
    return 768;
  }

  static sortAscByName(a, b) {
    let nameA = "";
    let nameB = "";

    if (!Util.isNullOrEmpty(a.name)) {
      nameA = a.name;
    }
    if (!Util.isNullOrEmpty(b.name)) {
      nameB = b.name;
    }

    if (nameA === "" && nameB === "") {
      return 0;
    }

    else if (nameA === "") {
      return 1;
    }

    else if (nameB === "") {
      return -1;
    }

    if (nameA.toLowerCase() < nameB.toLowerCase()) {
      return -1;
    }

    if (nameA.toLowerCase() > nameB.toLowerCase()) {
      return 1;
    }

    return 0;
  }

  static makeTextSentenceCase(text) {
    try {
      let textWithSpaces = text.replace(/([A-Z])/g, " $1");
      let sentenceCaseText = textWithSpaces.charAt(0).toUpperCase() +
        textWithSpaces.slice(1);

      return sentenceCaseText;
    }
    catch (error) {
      return "";
    }
  }

  static makeTextSentenceLowerCase(text) {
    try {
      let textWithSpaces = text.replace(/([A-Z])/g, " $1");
      let sentenceCaseText = textWithSpaces.charAt(0).toLowerCase() +
        textWithSpaces.slice(1);

      return sentenceCaseText;
    }
    catch (error) {
      return "";
    }
  }

  static transformValidationText(text) {
    try {
      if (text.includes("field is required")) {
        return "This field is required.";
      }
    }
    catch (error) {
      return "";
    }

    return text;
  }

  static makeColumnsSentenceCase(rows, excludes = new Array(0)) {
    let tempRows = [];

    for (let i = 0; i < rows.length; i++) {
      let tempObject = {};

      for (let j = 0; j < Object.keys(rows[i]).length; j++) {
        let excluded = false;

        for (let k = 0; k < excludes.length; k++) {
          if (Object.keys(rows[i])[j] == excludes[k]) {
            tempObject[Object.keys(rows[i])[j]] = Object.values(rows[i])[j];

            excluded = true;
          }
        }

        if (!excluded) {
          tempObject[
            Util.makeTextSentenceCase(Object.keys(rows[i])[j])] = Object.values(rows[i])[j];
        }
      }

      tempRows.push(tempObject);
    }

    return tempRows;
  }

  static tableToString(rows, seperator) {
    let textAsString = Object.keys(rows[0]).join(seperator) + "\n"

    for (let i = 0; i < rows.length; i++) {
      textAsString += Object.values(rows[i]).join(seperator) + "\n"
    }

    return textAsString;
  }

  static changeAllCommasToAnotherCharacter(rows, seperator) {
    let tempRows = rows;
    for (let i = 0; i < tempRows.length; i++) {
      for (let j = 0; j < Object.keys(tempRows[i]).length; j++) {
        if (!Util.isNullOrEmpty(Object.values(tempRows[i])[j]) && Object.values(tempRows[i])[j].toString().includes(",")) {
          tempRows[i][Object.keys(tempRows[i])[j]] =
            Object.values(tempRows[i])[j].replace(/,/g, seperator);
        }
      }
    }

    return tempRows;
  }

  static copyTableToClipboard(
    dataTableObject,
    excludeList = new Array(0)
  ) {
    navigator.clipboard.writeText(
      Util.tableToString(
        Util.makeColumnsSentenceCase(
          dataTableObject,
          excludeList
        ),
        "\t"
      )
    );
  }

  static exportToExcel(
    worksheetName,
    workbookName,
    data,
    excludeList = new Array(0)
  ) {
    // Create new Worksheet with data
    let worksheet = XLSX.utils.json_to_sheet(
      Util.makeColumnsSentenceCase(data, excludeList)
    );
    // Create new Workbook
    let workbook = XLSX.utils.book_new();
    // Name the Worksheet
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      worksheetName
    );
    // Name and open new Workbook
    XLSX.writeFile(workbook, workbookName);
  }

  static exportToCsv(name, rows, excludes = new Array(0)) {
    let csvContent = "data:text/csv;charset=utf-8,";
    let nonCommaRows = Util.changeAllCommasToAnotherCharacter(rows, "|");

    csvContent += Util.tableToString(
      Util.makeColumnsSentenceCase(nonCommaRows, excludes), ","
    );
    const data = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", data);
    link.setAttribute("download", name);
    link.click();
  }

  // this is a dynamic mapper that allows
  // you to specify the columns you want in the 
  //set aswell as rename the columns by setting the map ie..
  //{[new column name]: [old column name] }
  static mapTheData(rows = [], mapper = {}) {
    let values = Object.values(mapper);// get the vals to compare later
    //map the data map
    return rows.map(row => {
      let map = {};
      for (const item in row) {
        if (!values.includes(item)) continue;
        let property = Object.keys(mapper).find(key => mapper[key] === item);
        map[property] = row[item];
      }

      return map;
    });
  }

  static createHeaders(keys) {
    var result = [];
    for (var i = 0; i < keys.length; i += 1) {
      result.push({
        id: keys[i],
        name: keys[i],
        prompt: keys[i],
        width: 65,
        align: "center",
        padding: 0,
      });
    }
    return result;
  }

  static exportToPdf(name, rows, excludes = new Array(0)) {
    var headers = []; // Table headers.
    var headersWithOuterArray = []; // headers (which is an array) must be inside another array, to work correctly.

    var modifiedRows = Util.makeColumnsSentenceCase(rows, excludes); // modifiedDataTableObject = better formatted version of dataTableObject.

    for (let i = 0; i < Object.keys(modifiedRows[0]).length; i++) {
      // Save all headers to headers variable.
      headers.push(Object.keys(modifiedRows[0])[i]);
    }

    headersWithOuterArray.push(headers); // Push headers into headersWithOuterArray (this is necessary for jsPDF to work).

    // modifiedDataTableObject has key value pairs.  We only need the values.  Hence "modifiedDataTableObjectsWithOnlyValues".
    var modifiedDataTableObjectWithOnlyValues = [];
    for (let i = 0; i < modifiedRows.length; i++) {
      var item = [];

      for (let j = 0; j < Object.keys(modifiedRows[i]).length; j++) {

        item.push(Object.values(modifiedRows[i])[j]);
      }

      modifiedDataTableObjectWithOnlyValues.push(Object.assign({}, item));
    }

    var styleMap = {};

    for (let i = 0; i < headers.length - 1; i++) {
      styleMap[i] = { halign: "left", fontStyle: "bold", cellWidth: 'auto', minCellWidth: 18 }
    }

    // set the last column width short
    styleMap[headers.length - 1] = { halign: "left", fontStyle: "bold", cellWidth: 26, maxCellWidth: 26 };


    var doc = new jsPDF("landscape"); // Landscape is the orientation of the PDF page

    doc.autoTable({
      head: headersWithOuterArray,
      body: modifiedDataTableObjectWithOnlyValues,
      tableWidth: 'auto',
      headStyles: { fillColor: [39, 93, 52] },
      theme: "grid",
      style: { halign: 'center' },
      columnStyles: styleMap,
    });
    doc.save(name);
  }

  static setFuseSearch(data, keysArray) {
    return new Fuse(data, { keys: keysArray, threshold: 0.3 });
  }

  static fuseSearch(data, fuseSearch, value) {
    return value !== "" ? fuseSearch.search(value) : data;
  }

  static searchedData(data, searchedData, from, to) {
    return searchedData.length > 0
      ? searchedData.slice(from, to)
      : data.slice(from, to);
  }

  static toPaginationPage(pagination, total) {
    let highBound =
      Util.fromPaginationPage(pagination) + pagination.perPage;
    return total < highBound ? total : highBound;
  }

  static fromPaginationPage(pagination) {
    return pagination.perPage * (pagination.currentPage - 1);
  }

  static numberOfPaginationPages(searchedData, data) {
    return searchedData.length > 0
      ? searchedData.length
      : data.length;
  }

  static getInitialPaginationInfo() {
    return {
      perPage: 5,
      currentPage: 1,
      total: 0,
      perPageOptions: [5, 10, 20],
    };
  }

  static swalConfirmation(
    iconOfAlert,
    message,
    title = "",
    confirmButtonText = "Okay",
    showCancelButton = false
  ) {
    // Using new swall since we are uisng v11
    return new swal({
      title: `${title}`,
      html: `${message}`,
      icon: iconOfAlert,
      showCancelButton: showCancelButton,
      confirmButtonColor: "#10b45a",
      confirmButtonText: `${confirmButtonText}`,
      reverseButtons: true,
    });
  }

  // For Easter timezone

  // static formatDateWithLocalTimezone(currentDate , format) {
  //   if (!currentDate) {
  //     return null;
  //   }
  //   return moment_timezone.tz(currentDate, format, 'America/New_York').tz(moment_timezone.tz.guess()).format("MMMM DD, YYYY hh:mm A");
  // }

  static formatDateWithLocalTimezone(currentDate) {
    if (!currentDate) {
      return null;
    }
    return moment
      .utc(currentDate)
      .local()
      .format("MMMM DD, YYYY hh:mm A");
  }

  static convertToDateOnly(currentDate) {
    if (!currentDate) {
      return null;
    }
    return moment(currentDate).format("DD-MMMM-YYYY");
  }

  static isSupportedFile(
    filename,
    allowedExtensions = /(\.pdf|\.png|\.jpg|\.jpeg|\.docx|\.doc|\.csv|\.xls|\.xlsx|\.txt|\.pptx|\.ppt|\.msg)$/i
  ) {
    return allowedExtensions.exec(filename) ? true : false;
  }

  /**
   * Converts a string to Title Case (e.g., "SIGNATURE AUTHORITY" -> "Signature Authority")
   * @param {string} str - The string to convert
   * @returns {string} The title-cased string
   */
  static toTitleCase(str) {
    if (!str) return '';
    return str
      .toLowerCase()
      .split(/[\s_-]+/g)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  /**
   * Format value based on its data type from the backend
   * @param {string} value - The value to format
   * @param {string} valueDataType - The data type (DateTime, Boolean, Integer, Decimal, String, Guid, Enum)
   * @returns {string} Formatted value
   */
  // Time format options: '12h' for 12-hour AM/PM, '24h' for military time
  static TIME_FORMAT_12H = '12h';
  static TIME_FORMAT_24H = '24h';

  static formatValue(value, valueDataType, timeFormat = '24h') {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    
    const dataType = (valueDataType || '').toLowerCase();
    
    switch (dataType) {
      case 'datetime':
        // Format DateTime values based on timeFormat parameter
        try {
          const date = new Date(value);
          if (!isNaN(date.getTime())) {
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const year = date.getFullYear();
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            
            switch (timeFormat) {
              case '12h': {
                // 12-hour format with AM/PM
                const hour24 = date.getHours();
                const ampm = hour24 >= 12 ? 'PM' : 'AM';
                const hour12 = hour24 % 12 || 12;
                const displayHours = String(hour12).padStart(2, '0');
                return `${month}/${day}/${year} ${displayHours}:${minutes}:${seconds} ${ampm}`;
              }
              case '24h':
              default: {
                // 24-hour military time (default)
                const hours = String(date.getHours()).padStart(2, '0');
                return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
              }
            }
          }
        } catch (e) {
          // Fall through to return original value
        }
        return value;
        
      case 'boolean': {
        // Convert true/false to Yes/No
        const boolVal = String(value).toLowerCase();
        if (boolVal === 'true') return 'Yes';
        if (boolVal === 'false') return 'No';
        return value;
      }
        
      case 'integer':
      case 'decimal':
        // Format numbers with commas
        try {
          const num = parseFloat(value);
          if (!isNaN(num)) {
            return dataType === 'decimal' 
              ? num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
              : num.toLocaleString('en-US');
          }
        } catch (e) {
          // Fall through to return original value
        }
        return value;
        
      case 'guid':
        // Return GUID as-is
        return value;
        
      case 'enum':
      case 'string':
      default:
        // Return string values as-is
        return value;
    }
  }
}
